// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"4a2441bf","257":"2578de06","273":"01d7f849","304":"8f3bbf20"}[chunkId] + ".chunk.js";
};